module.exports = __webpack_public_path__ + "img/imp.1446d915.png";